import React, { useEffect, useState } from 'react'
import { Dimensions, Image, View, Text, ActivityIndicator } from 'react-native'
import { PinchView } from 'react-native-pinch-view'
import { placeholderGeneral } from '../Constants' // TODO: este placeholder debe venir de assets del repositorio
import styles from './ImageWithZoomStyles'
import { searchFile } from './ImageWIthZoom'
import { getImageSize, validateConnectionNetwork } from '../../../utils/functions.utils'
import theme from '../../../../theme'
const deviceWidth = Dimensions.get('window').width

// export const ImageWithZoomContain = ({ uri, path }) => {
//     console.log("🚀 ~ ImageWithZoomContain ~ path:", path)
//     const [imageHeight, setImageHeight] = useState(0)
//     const [image, setImage] = useState(uri)

//     useEffect(() => {
//         if (uri) {
//             Image.getSize(
//                 uri,
//                 (width, height) => {
//                     const ratio = height / width
//                     const calculatedHeight = deviceWidth * ratio
//                     setImageHeight(calculatedHeight)
//                 },
//                 (error) => {
//                     console.error('Error al obtener el tamaño de la imagen: ', error)
//                 },
//             )
//         }
//     }, [uri])
//     return (
//         <PinchView>
//             <Image
//                 source={{ uri: image }}
//                 style={[
//                     styles.imageWithZoomContain,
//                     {
//                         height: imageHeight,
//                     },
//                 ]}
//                 resizeMode='contain'
//             />
//         </PinchView>
//     )
// }

// @Fixme - This is the final version of the snippet for local images
export const ImageWithZoomContain = ({ uri, path }) => {
    const [imageHeight, setImageHeight] = useState(500)
    const [image, setImage] = useState({ uri: uri })
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        setIsLoading(true)
        
        if (!uri) {
            setImage({ uri: placeholderGeneral })
            setIsLoading(false)
            return
        }
        if (!path || path.trim() === '') {
            setImage(uri)
            setIsLoading(false)
            return
        }
        
        const fetchImage = async () => {
            try {
                let image = await searchFile(uri, path)
                const isConnection = await validateConnectionNetwork()

                if (image.includes('http') && isConnection) {
                    Image.getSize(image, (width, height) => {
                        const ratio = height / width
                        const calculatedHeight = deviceWidth * ratio
                        setImageHeight(calculatedHeight)
                        setIsLoading(false)
                    }, (error) => {
                        console.error('Error obteniendo dimensiones de imagen remota:', error)
                        setImageHeight(deviceWidth)
                        setIsLoading(false)
                    })
                    setImage({ uri: image })
                } else {
                    const { height, width } = await getImageSize(image)
                    if (height && width) {
                        const ratio = height / width
                        const calculatedHeight = deviceWidth * ratio
                        setImageHeight(calculatedHeight)
                        setImage({ uri: image })
                    } else {
                        setImageHeight(deviceWidth)
                        setImage({ uri: image })
                    }
                    setIsLoading(false)
                }
            } catch (error) {
                console.error('Error cargando imagen:', error)
                setImageHeight(deviceWidth)
                setImage({ uri: placeholderGeneral })
                setIsLoading(false)
            }
        }
        fetchImage()
    }, [uri, path]) // ✅ Agregar dependencias para que reaccione a cambios

    // useEffect(() => {
    //     if (image) {
    //         let newImage = image.uri ? image.uri : image
    //         Image.getSize(
    //             newImage,
    //             (width, height) => {
    //                 const ratio = height / width
    //                 const calculatedHeight = deviceWidth * ratio
    //                 setImageHeight(calculatedHeight)
    //             },
    //             (error) => {
    //                 console.error('Error al obtener el tamaño de la imagen: ', error)
    //             },
    //         )
    //     }
    // }, [image])
    return (
        <PinchView>
            {isLoading && (
                <View 
                    style={{ 
                        position: 'absolute', 
                        top: 0, 
                        left: 0, 
                        right: 0, 
                        bottom: 0, 
                        justifyContent: 'center', 
                        alignItems: 'center',
                        backgroundColor: 'rgba(0,0,0,0.05)',
                        zIndex: 10 
                    }}
                >
                    <ActivityIndicator size="large" color={theme.colors.colorPrimary} />
                    <Text style={{ color: theme.colors.textSecondary, fontSize: 14, marginTop: 8 }}>
                        Cargando imagen...
                    </Text>
                </View>
            )}
            <Image
                source={image}
                style={[
                    styles.imageWithZoomContain,
                    {
                        height: imageHeight,
                        width: deviceWidth,
                    },
                ]}
                resizeMode='contain'
                onLoad={() => setIsLoading(false)}
                onError={(error) => {
                    console.error('Error cargando imagen:', error.nativeEvent?.error)
                    setIsLoading(false)
                }}
            />
        </PinchView>
    )
}
